import { useState, useEffect } from "react"
import QuantityInput from "./QuantityInput"
import Button from "@/common/button/button"
import { useCartContext } from "@/components/woocommerce/cartStore"
import { useMeta } from "@/lib/contexts/appContext"
import useLocalShop from "@/lib/hooks/useLocalShop"

const AddToCart = ({
  product,
  defaultQty = 1,
  ctaText = "Lägg i varukorg",
  variation = [],
  customPrice = false,
  hideQuantity = false,
  callback = false,
  campaignCode = false
}) => {
  const { nonce, isLoading, fetchCart, addCartItem } = useCartContext()
  const { setCart } = useLocalShop()
  const [cartLoading, setCartLoading] = useState(false)
  const [addProduct, setProduct] = useState(false)
  const [currentQty, setCurrentQty] = useState(defaultQty)
  const {
    woocommerce: { shop_enabled }
  } = useMeta()

  useEffect(() => {
    if (!nonce) {
      return
    }

    if (addProduct) {
      setProduct(false)
      try {
        requestAddItem()
      } finally {
        setCartLoading(false)
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nonce])

  const requestAddItem = async () => {
    const status = await addCartItem(
      product,
      currentQty,
      variation,
      customPrice,
      campaignCode
    )

    if (callback) {
      callback(status)
    }

    return status
  }

  const handleAddToCart = async () => {
    setCartLoading(true)
    setCart()

    if (!nonce) {
      await fetchCart()
      setProduct(true)
      return
    }

    try {
      requestAddItem()
    } finally {
      setCartLoading(false)
    }
  }

  if (!shop_enabled) {
    return null
  }

  return (
    <div className="flex flex-col flex-auto mt-4 sm:flex-row sm:flex-nowrap">
      {hideQuantity && (
        <QuantityInput
          maximum={product.quantity_limit}
          className="mb-4 sm:mb-0 sm:pr-6"
          defaultQty={defaultQty}
          setCurrentQty={(qty) => setCurrentQty(qty)}
        />
      )}
      <Button
        className="w-full"
        ariaLabel={ctaText}
        onClick={handleAddToCart}
        theme="green"
        loading={cartLoading || isLoading}
        disabled={cartLoading || isLoading}>
        {ctaText}
      </Button>
    </div>
  )
}

export default AddToCart
